<i18n lang='yml' src='../i18n/ContentBlockShare.yml'></i18n>

<template>
    <fieldset>
        <legend class="tab-heading">{{ $t('header') }}</legend>
        <div class='form-group'>
            <label for='content-block-share-vue-location'>{{ $t('location') }}</label>
            <select id='content-block-share-vue-location' class='form-control' v-model='selected'>
                <option value='personal'>{{ $t('personal') }}</option>
                <option v-for='container in containers' :value='container.id'>{{ container.name }}</option>
            </select>
        </div>

        <div class='form-group'>
            <input type='hidden' :name='fieldName + "[shareable]"' value=''>
            <label for='content-block-share-vue-shareables'>{{ $t('destination') }}</label>
            <select id='content-block-share-vue-shareables' class='form-control share' :name='fieldName + "[shareable]"'>
                <template v-if='selected === "personal"'>
                    <template v-for='shareableGroup in personal'>
                        <optgroup :label='shareableGroup.label'>
                            <option v-for='shareable in shareableGroup.shareables' :value='shareable.type + "_" + shareable.id'>{{ shareable.label }}</option>
                        </optgroup>
                    </template>
                </template>
                <template v-else>
                    <template v-for='shareableGroup in shareableGroups'>
                        <optgroup :label='shareableGroup.label'>
                            <option v-for='shareable in shareableGroup.shareables' :value='shareable.type + "_" + shareable.id'>{{ shareable.label }}</option>
                        </optgroup>
                    </template>
                </template>
            </select>
        </div>

        <div class='form-group'>
            <input type='submit' class='btn btn-success' :value='$t("share")'>
        </div>
    </fieldset>
</template>

<script>
    import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';
    export default {
        props: ['locale', 'endpoint', 'fieldName'],
        data () {
            return { personal: [], containers: [], selected: 'personal' }
        },
        mounted () {
            this.$i18n.locale = this.locale;

            const self = this;
            sendAjaxRequest('GET', self.endpoint + '.json', 'json', {}, this.ajaxSuccess);
        },
        computed: {
            shareableGroups: function () {
                const selected = this.containers.find((c) => c.id === this.selected);
                if (selected) {
                    return selected.shareable_groups;
                }
            }
        },
        methods: {
          ajaxSuccess(data) {
            this.personal = data.personal.shareable_groups;
            this.containers = data.containers;
          }
        }
    }
</script>
